import { useStepsStore } from '../../stores/StepsStore';

export const RegistrationFooter = (props: { openGCLModal: () => void; }) => {
    const { currentStep } = useStepsStore();

    return <div className="ncf-footer">
        {currentStep === 'gcl' ?
            <div className="gcl-footer-note">
                If you do not wish to pay by Direct Debit, please phone our team on <a href="tel:+448083043719">0808 304 3719</a> to complete your registration.
            </div>
            : ''}
        <img src={(window as any).ncf_gcl_url} /><span>safely powers all our payments <button style={{ border: '0px' }} onClick={props.openGCLModal}><img width={'15px'} height={'15px'} src={(window as any).gcl_exclamation} /></button></span>
    </div>;
}